import React from 'react'
import assets from '../../constants/assets';
import { Box, Typography } from '@mui/material'

const NoData = ({ textValue = 'No Data Available' }) => {
  return (
    <div style={{ margin: '0 auto' }}>
      <Box
        component="img"
        sx={{
          height: 150,
          width: 150,
          paddingTop: 2,
          display: 'block',
          margin: '0 auto'
        }}
        alt="No Data Available"
        src={assets.Magnify}
      />
      <Typography variant="body1" textAlign="center" sx={{ margin: '30px 0' }}>{textValue}</Typography>
    </div>
  )
}

export default NoData;
